// Client-side image compression using Canvas.
// Compresses to max 1200px wide, JPEG 75% quality.
// Returns a data URL string (base64) ready to send to backend.
export async function compressImageFile(file, { maxDim = 1200, quality = 0.75, mime = 'image/jpeg' } = {}) {
  if (!file || !file.type?.startsWith('image/')) throw new Error('File bukan gambar');
  const bitmap = await createImageBitmap(file);
  let { width, height } = bitmap;
  if (width > maxDim || height > maxDim) {
    if (width >= height) {
      height = Math.round((height / width) * maxDim);
      width = maxDim;
    } else {
      width = Math.round((width / height) * maxDim);
      height = maxDim;
    }
  }
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  ctx.drawImage(bitmap, 0, 0, width, height);
  const dataUrl = canvas.toDataURL(mime, quality);
  bitmap.close?.();
  return dataUrl;
}

export function estimateBase64Size(dataUrl) {
  if (!dataUrl) return 0;
  const b64 = dataUrl.split(',')[1] || '';
  return Math.floor(b64.length * 0.75);
}
